module.exports = __webpack_public_path__ + "img/Sustainable-scalability.6c118ee1.png";